      function setCookie(name, value, hours) {
        const d = new Date();
        d.setTime(d.getTime() + (hours * 60 * 60 * 1000));
        const expires = "expires=" + d.toUTCString();
        document.cookie = name + "=" + value + ";" + expires + ";path=/";
      }
    
      function getCookie(name) {
        const cookieName = name + "=";
        const decodedCookie = decodeURIComponent(document.cookie);
        const cookieArray = decodedCookie.split(';');
        for (let i = 0; i < cookieArray.length; i++) {
          let cookie = cookieArray[i];
          while (cookie.charAt(0) === ' ') {
            cookie = cookie.substring(1);
          }
          if (cookie.indexOf(cookieName) === 0) {
            return cookie.substring(cookieName.length, cookie.length);
          }
        }
        return "";
      }
    
      function getRandomNumber(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
      }
    
      function updatestockCount() {
        const productId = document.body.getAttribute('data-product__it__fr_cnt');;
        if(!productId) return;
        const cookieName = "stockCount_" + productId;
        let stockCount = getCookie(cookieName);
    
        if (stockCount === "") {
          stockCount = getRandomNumber(1, 25);
          setCookie(cookieName, stockCount, 1);
        }
    
        const elements = document.getElementsByClassName("stockCount");
        for (let i = 0; i < elements.length; i++) {
          elements[i].textContent = stockCount;
        }
      }
    
      updatestockCount();

const countryFlags = {
  'US': '🇺🇸',
  'CA': '🇨🇦',
  'FR': '🇫🇷',
  'NL': '🇳🇱',
  'DE': '🇩🇪',
  'GB': '🇬🇧',
  'IT': '🇮🇹',
  'ES': '🇪🇸',
  'CN': '🇨🇳',
  'JP': '🇯🇵',
  'BR': '🇧🇷',
  'IN': '🇮🇳',
  'RU': '🇷🇺',
  'ZA': '🇿🇦',
  'AU': '🇦🇺',
  'NZ': '🇳🇿',
  'MX': '🇲🇽',
  'AR': '🇦🇷',
  'CL': '🇨🇱',
  'CO': '🇨🇴',
  'PE': '🇵🇪',
  'VE': '🇻🇪',
  'EC': '🇪🇨',
  'GT': '🇬🇹',
  'HN': '🇭🇳',
  'SA': '🇸🇦',
  'AE': '🇦🇪',
  'TR': '🇹🇷',
  'TH': '🇹🇭',
  'MY': '🇲🇾',
  'SG': '🇸🇬',
  'ID': '🇮🇩',
  'PH': '🇵🇭',
  'VN': '🇻🇳',
  'KR': '🇰🇷',
  'KP': '🇰🇵',
  'SE': '🇸🇪',
  'NO': '🇳🇴',
  'FI': '🇫🇮',
  'DK': '🇩🇰',
  'IS': '🇮🇸',
  'IE': '🇮🇪',
  'CH': '🇨🇭',
  'PT': '🇵🇹',
  'BE': '🇧🇪',
  'LU': '🇱🇺',
  'PL': '🇵🇱',
  'CZ': '🇨🇿',
  'SK': '🇸🇰',
  'HU': '🇭🇺',
  'AT': '🇦🇹',
  'LI': '🇱🇮',
  'GR': '🇬🇷',
  'BG': '🇧🇬',
  'RO': '🇷🇴',
  'UA': '🇺🇦',
  'BY': '🇧🇾',
  'LT': '🇱🇹',
  'LV': '🇱🇻',
  'EE': '🇪🇪',
  'MD': '🇲🇩',
  'AM': '🇦🇲',
  'GE': '🇬🇪',
  'AZ': '🇦🇿',
  'IR': '🇮🇷',
  'IQ': '🇮🇶',
  'SY': '🇸🇾',
  'LB': '🇱🇧',
  'JO': '🇯🇴',
  'IL': '🇮🇱',
  'EG': '🇪🇬',
  'MA': '🇲🇦',
  'DZ': '🇩🇿',
  'TN': '🇹🇳',
  'LY': '🇱🇾',
  'GM': '🇬🇲',
  'SN': '🇸🇳',
  'MR': '🇲🇷',
  'ML': '🇲🇱',
  'GN': '🇬🇳',
  'CI': '🇨🇮',
  'BF': '🇧🇫',
  'NE': '🇳🇪',
  'TG': '🇹🇬',
  'BJ': '🇧🇯',
  'NG': '🇳🇬',
  'CM': '🇨🇲',
  'GA': '🇬🇦',
  'CG': '🇨🇬',
  'CD': '🇨🇩',
  'AO': '🇦🇴',
  'GW': '🇬🇼',
  'SC': '🇸🇨',
  'SD': '🇸🇩',
  'RW': '🇷🇼',
  'ET': '🇪🇹',
  'SO': '🇸🇴',
  'DJ': '🇩🇯',
  'KE': '🇰🇪',
  'TZ': '🇹🇿',
  'UG': '🇺🇬',
  'BI': '🇧🇮',
  'MZ': '🇲🇿',
  'ZM': '🇿🇲',
  'MW': '🇲🇼',
  'LS': '🇱🇸',
  'BW': '🇧🇼',
  'NA': '🇳🇦',
  'ZA': '🇿🇦',
  'SZ': '🇸🇿',
  'PK': '🇵🇰'
};


function setLocationInfo(countryCode, countryName) {
  const flagEmoji = countryFlags[countryCode];
  if(flagEmoji){
  document.body.style.setProperty('--shipping-message-cstmm', `"${countryName} ${flagEmoji}"`);    
  }else{
  document.body.style.setProperty('--shipping-message-cstmm', `"${countryName}"`);    
  }
}

async function fetchLocationInfo() {
  try {
    const response = await fetch('/browsing_context_suggestions.json');
    const data = await response.json();
    const countryCode = data.detected_values.country.handle;
    const countryName = data.detected_values.country.name?.toUpperCase();

    
    setLocationInfo(countryCode, countryName);
  } catch (error) {
    console.error('Error fetching location info:', error);
  }
}

document.addEventListener('DOMContentLoaded', (event) => {
  fetchLocationInfo();
});
